import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";
import { UserRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { LoginFormComponent } from './form/component';
import { BrandModule } from "../brand/brand.module";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    UserRoutingModule,
    FormsModule,
    SharedModule,
    BrandModule,
    FontAwesomeModule
  ],
  declarations: [
    LoginComponent,
    LoginFormComponent
  ],
})
export class LoginModule { }


// WEBPACK FOOTER //
// ./src/app/public/login/login.module.ts